import {
  AttachMoney,
  CreditCard,
  Dashboard,
  List,
  Receipt,
  Settings,
  Search,
  PageviewOutlined,
  HeadsetMicRounded,
  Inbox,
  InsertDriveFile,
} from '@mui/icons-material'
import { Work, People } from '@mui/icons-material'
import * as React from 'react'
import AdminPages from './adminPages/AdminPages'
import BillOut from './billOut/BillOut'
import Bills from './bills/Bills'
import WriteChecks from './bills/writeChecks/WriteChecks'
import PendingChecks from './bills/PendingChecks'
import BodyParts from './bodyParts/BodyParts'
import Components from './components/Components'
import EditComponent from './components/EditComponent'
import Constants from './config'
import ContactTypes from './contactTypes/ContactTypes'
import CptCodes from './cptCodes/CptCodes'
import DashboardPage from './dashboardPage/DashboardPage'
import DxCodes from './dxCodes/DxCodes'
import EmployerEdit from './employers/EmployerEdit'
import Employers from './employers/Employers'
import InsuranceCompanies from './insuranceCompanies/InsuranceCompanies'
import InsuranceCompany from './insuranceCompanies/InsuranceCompany'
import MagicLinkRequest from './login/MagicLinkRequest'
import MagicLinkVerify from './login/MagicLinkVerify'
import MagicLinkRedirect from './login/MagicLinkRedirect'
import MedicareCostLookups from './medicareCostLookups/MedicareCostLookups'
import MultipleProcedureDiscountExclusionCodes from './multipleProcedureDiscountExclusionCodes/MultipleProcedureDiscountExclusionCodes'
import NurseCaseManager from './nurseCaseManagers/NurseCaseManager'
import NurseCaseManagers from './nurseCaseManagers/NurseCaseManagers'
import EditCompany from './organizations/EditCompany'
import EditEpisodeOfCare from './patients/EpisodesOfCare/EditEpisodeOfCare'
import Patient from './patients/Patient'
import EditReferral from './patients/PatientReferrals/EditReferral'
import Patients from './patients/Patients'
import PreExistingConditions from './preExistingConditions/PreExistingConditions'
import Procedures from './procedures/Procedures'
import EditProvider from './providers/EditProvider'
import Quotes from './quotes/Quotes'
import ReceiveClaim from './ReceiveClaim/ReceiveClaim'
import ReceivePayment from './receivePayment/ReceivePayment'
import EditReferringDoctor from './referringDoctors/EditReferringDoctor'
import ReferringDoctors from './referringDoctors/ReferringDoctors'
import FinancialResearch from './search/FinancialResearch'
import { IRoute } from './routing'
import EditSchedule from './schedules/EditSchedule'
import Tags from './Tags/Tags'
import Users from './users/Users'
import { OrganizationId } from './utils/OrganizationIds'
import CreateGlobalInvoice from './quotes/globalInvoice/CreateGlobalInvoice'
import { EasyQuery } from './easyQuery/EasyQuery'
import ClaimsAcquisition from './claimsAcquisition/ClaimsAcquisition'
import { CashRefund } from 'mdi-material-ui'
import ProviderRefunds from './providerRefunds/providerRefunds'
import PatientDocuments from './patients/PatientDocuments'
import FileBrowser from './common/FileBrowser/FileBrowserDialog'
import ReceivedChecks from './receivedChecks/ReceivedChecks'
import SentChecks from './SentChecks/SentChecks'
import ProviderGroups from './providers/ProviderGroups'
import DocumentInbox from './workflow/DocumentInbox'
import QuoteInbox from './workflow/QuoteInbox'
import ClaimInbox from './workflow/ClaimInbox'
import Inboxes from './workflow/Inboxes'
import viewClaim from './viewClaim/viewClaim'
import BillOutInbox from './workflow/BillOutInbox'
import InvoiceInbox from './workflow/InvoiceInbox'
import CaseInbox from './workflow/CaseInbox'
import CreateCombined1500 from './quotes/CreateCombined1500'
import EditConsumerQuote from './quotes/EditConsumerQuote/index'
import CopyQuote from './quotes/CopyQuote'
import CaseSearch from './obmCaseSearch/CaseSearch'
import ReferralSource from './obmReferral/ReferralSource'
import ReferralContact from './obmReferral/EditReferralSource'
import ReferralSpeciality from './obmReferral/ReferralSpeciality'
import ObmReceivedChecks from './obmReceivedChecks/ReceivedChecks'
import InvoiceType from './invoice/InvoiceType'
import AdvancedReportConfiguration from './advancedReportConfig/AdvancedReportConfiguration'
import DocumentSearch from './search/DocumentSearch'
import { SvgIconProps } from '@mui/material'
interface INavigationSection {
  header?: string
  navigationRoutes: INavigationRoute[]
}

interface INavigationRoute extends IRoute {
  icon: React.ReactElement<SvgIconProps>
  text: string
  isDynamic?: boolean | undefined
}

const routes: IRoute[] = [
  {
    component: MagicLinkRedirect,
    exact: true,
    path: '/login',
  },
  {
    component: MagicLinkRequest,
    exact: true,
    path: '/login/magic-link',
  },
  {
    component: MagicLinkVerify,
    exact: true,
    path: '/magic-link',
  },
  {
    allowedRoles: [
      Constants.ObxRoles.Administrator,
      Constants.ObxRoles.ProviderInfoUpdater,
    ],
    component: EditProvider,
    exact: true,
    path: `/providers/:providerId`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EditProvider,
    exact: true,
    path: '/providers/create',
  },

  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EmployerEdit,
    exact: true,
    path: `/admin/employers/:employerId`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EmployerEdit,
    exact: true,
    path: '/admin/employers/create',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: Employers,
    exact: true,
    path: '/admin/employers',
  },
  {
    allowedRoles: [
      Constants.ObxRoles.Administrator,
      Constants.ObxRoles.FinanceTier3,
      Constants.ObxRoles.FinanceManager,
    ],
    component: CreateGlobalInvoice,
    exact: true,
    path: `/quotes/:quoteId/globalInvoice/:actionId`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: ReceiveClaim,
    exact: true,
    path: `/quotes/claim`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: PreExistingConditions,
    exact: true,
    path: '/admin/preexistingconditions',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: Tags,
    exact: true,
    path: '/admin/tags',
  },
  {
    component: ReceiveClaim,
    exact: true,
    path: `/claim/quote/:quoteId`,
  },
  {
    component: CopyQuote,
    exact: true,
    path: `/claim/quote/:quoteId/copy`,
  },
  {
    component: CopyQuote,
    exact: true,
    path: `/workflow/quote/:quoteId/copy`,
  },
  {
    component: ReceiveClaim,
    exact: true,
    path: `/claim/episodeOfCare/:episodeOfCareId`,
  },
  {
    component: ReceiveClaim,
    exact: true,
    path: `/claim/:claimId/quote/:quoteId`,
  },
  {
    component: ReceiveClaim,
    exact: true,
    path: `/claim/:claimId/episodeOfCare/:episodeOfCareId`,
  },
  {
    component: ReceiveClaim,
    exact: true,
    path: `/claim/:claimId/episodeOfCare/:episodeOfCareId/appealType/:appealType`,
  },
  {
    component: viewClaim,
    exact: true,
    path: `/claim/:claimId/episodeOfCare/:episodeOfCareId/view`,
  },
  {
    allowedRoles: [
      Constants.ObxRoles.Administrator,
      Constants.ObxRoles.FinanceTier3,
      Constants.ObxRoles.FinanceManager,
    ],
    component: Bills,
    exact: true,
    path: `/payproviders/review/:providerId`,
  },
  {
    allowedRoles: [
      Constants.ObxRoles.Administrator,
      Constants.ObxRoles.FinanceTier3,
      Constants.ObxRoles.FinanceManager,
    ],
    component: WriteChecks,
    exact: true,
    path: '/payproviders/checks',
  },
  {
    allowedRoles: [
      Constants.ObxRoles.Administrator,
      Constants.ObxRoles.FinanceTier3,
      Constants.ObxRoles.FinanceManager,
    ],
    component: PendingChecks,
    exact: true,
    path: '/payproviders/checks-holding',
  },
  {
    component: Patient,
    exact: true,
    path: `/patients/patient/:patientId`,
  },
  {
    component: Patient,
    exact: true,
    path: `/patients/patient`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: InsuranceCompanies,
    exact: true,
    path: `/admin/insuranceCompanies`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: InsuranceCompany,
    exact: true,
    path: `/admin/insuranceCompanies/insuranceCompany/:insuranceCompanyId?`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: MultipleProcedureDiscountExclusionCodes,
    exact: true,
    path: '/admin/exclusionCodes',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EditCompany,
    exact: true,
    path: '/admin/companyInfo',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: ReferringDoctors,
    exact: true,
    path: '/admin/referringDoctors',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: NurseCaseManagers,
    exact: true,
    path: `/admin/nurseCaseManagers`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: NurseCaseManager,
    exact: true,
    path: `/admin/nurseCaseManagers/nurseCaseManager/:nurseCaseManagerId?`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EditReferringDoctor,
    exact: true,
    path: `/admin/referringDoctors/referringDoctor/:referringDoctorId?`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EditReferringDoctor,
    exact: true,
    path: `/admin/referringDoctors/:referringDoctorId`,
  },
  {
    component: EditReferral,
    exact: true,
    path: `/patients/patient/:patientId/referral/:referralId?`,
  },
  {
    component: EditEpisodeOfCare,
    exact: true,
    path: `/patients/patient/:patientId/referral/:referralId/episodeOfCare/:episodeOfCareId?`,
  },
  {
    component: EditSchedule,
    exact: true,
    path: `/patients/patient/:patientId/referral/:referralId/episodeOfCare/:episodeOfCareId/schedule/:scheduleId?`,
  },
  {
    component: PatientDocuments,
    exact: true,
    path: `/patients/patient/:patientId/documents`,
  },
  {
    component: FileBrowser,
    exact: true,
    path: `/files`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: Components,
    exact: true,
    path: `/admin/components`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: EditComponent,
    exact: true,
    path: `/admin/components/component/:componentId?`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: ContactTypes,
    exact: true,
    path: `/admin/contactTypes`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: BodyParts,
    exact: true,
    path: `/admin/bodyParts`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: CptCodes,
    exact: true,
    path: '/admin/cptCodes',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: DxCodes,
    exact: true,
    path: '/admin/dxCodes',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: MedicareCostLookups,
    exact: true,
    path: '/admin/medicareCost',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: Procedures,
    exact: true,
    path: '/procedures',
  },
  {
    allowedRoles: [
      Constants.ObxRoles.Administrator,
      Constants.ObxRoles.ProviderInfoUpdater,
    ],
    component: ProviderGroups,
    exact: true,
    path: '/providers',
  },
  {
    allowedRoles: [Constants.ObxRoles.GeneralFinance, Constants.ObxRoles.Administrator],
    component: () => <SentChecks />,
    exact: true,
    path: '/admin/sentChecks',
  },
  {
    allowedRoles: [Constants.ObxRoles.GeneralFinance, Constants.ObxRoles.Administrator],
    component: () => <ReceivedChecks />,
    exact: true,
    path: '/admin/receivedChecks',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: () => <Users />,
    exact: true,
    path: '/users',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: () => <InvoiceType />,
    exact: true,
    path: '/invoice/invoiceType',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: () => <ReferralContact />,
    exact: true,
    path: `/admin/editReferralSourceContact/:rsId`,
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: () => <ReferralSource />,
    exact: true,
    path: '/admin/referralSource',
  },
  {
    allowedRoles: [
      Constants.OmxRoles.CaseManager,
      Constants.OmxRoles.CaseCoordinator,
      Constants.ObxRoles.Administrator,
    ],
    component: () => <ObmReceivedChecks />,
    exact: true,
    path: '/admin/receivedInvoicePaymentChecks',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator],
    component: () => <ReferralSpeciality />,
    exact: true,
    path: '/admin/referralSpeciality',
  },
  {
    allowedRoles: [Constants.ObxRoles.Administrator, Constants.ObxRoles.WorkflowAdmin],
    component: () => <AdvancedReportConfiguration />,
    exact: true,
    path: '/admin/advancedReportConfig',
  },
  {
    component: DocumentInbox,
    exact: true,
    path: `/workflow/document/file/:documentName`,
  },
  {
    component: DocumentInbox,
    exact: true,
    path: `/workflow/document/:documentId/inbox/:inboxId`,
  },
  {
    component: DocumentInbox,
    exact: true,
    path: `/workflow/document/:documentId/default-inbox`,
  },
  {
    component: QuoteInbox,
    exact: true,
    path: `/workflow/quote/:quoteId/inbox/:inboxId`,
  },
  {
    component: QuoteInbox,
    exact: true,
    path: `/workflow/quote/:quoteId/default-inbox`,
  },
  {
    component: ClaimInbox,
    exact: true,
    path: `/workflow/claim/:claimId/inbox/:inboxId`,
  },
  {
    component: ClaimInbox,
    exact: true,
    path: `/workflow/claim/:claimId/default-inbox`,
  },
  {
    component: ClaimInbox,
    exact: true,
    path: `/workflow/claim/:claimId/process-refunds-search`,
  },
  {
    component: CaseInbox,
    exact: true,
    path: `/workflow/case/:caseId/inbox/:inboxId`,
  },
  {
    component: CaseInbox,
    exact: true,
    path: `/workflow/case/:caseId/default-inbox`,
  },
  {
    component: BillOutInbox,
    exact: true,
    path: `/workflow/billout/:claimId/inbox/:inboxId`,
  },
  {
    component: BillOutInbox,
    exact: true,
    path: `/workflow/billout/:claimId/default-inbox`,
  },
  {
    component: InvoiceInbox,
    exact: true,
    path: `/workflow/invoice/:invoiceId/inbox/:inboxId`,
  },
  {
    component: InvoiceInbox,
    exact: true,
    path: `/workflow/invoice/:invoiceId/default-inbox`,
  },
  {
    component: BillOutInbox,
    exact: true,
    path: `/workflow/billout/:claimId/billout-search/:inboxId`,
  },
  {
    component: BillOutInbox,
    exact: true,
    path: `/workflow/billout/:claimId/default-billout-search/:inboxId`,
  },
  {
    component: BillOutInbox,
    exact: true,
    path: `/workflow/billout/:claimId/received-search-default`,
  },
  {
    component: BillOutInbox,
    exact: true,
    path: `/workflow/billout/:claimId/inbox/:inboxId/billout-search`,
  },
  {
    component: CreateCombined1500,
    exact: true,
    path: `/workflow/quote/:quoteId/createcombined1500/`,
  },
  {
    component: EditConsumerQuote,
    exact: true,
    path: `/workflow/quote/consume/:quoteId`,
  },
]

const navigationSection: INavigationSection = {
  navigationRoutes: [
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.CareCoordinator,
        Constants.ObxRoles.Administrator,
      ],
      component: () => <DashboardPage />,
      exact: true,
      icon: <Dashboard />,
      path: '/',
      text: 'Coordinator Dashboard',
    },
    {
      allowedOrganization: [OrganizationId.Surgical, OrganizationId.Medical],
      component: Inboxes,
      exact: true,
      icon: <Inbox />,
      path: `/workflow-inboxes`,
      text: 'Inboxes',
      isDynamic: true,
    },
    {
      allowedOrganization: [OrganizationId.Medical],
      component: () => <CaseSearch />,
      exact: true,
      icon: <Work />,
      path: '/cases',
      text: 'Cases',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      component: () => <Patients />,
      exact: true,
      icon: <People />,
      path: '/patients',
      text: 'Patients',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.Administrator,
        Constants.ObxRoles.FinanceTier2,
        Constants.ObxRoles.FinanceManager,
      ],
      component: () => <Quotes />,
      exact: true,
      icon: <List />,
      path: '/quotes',
      text: 'Quotes',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.Administrator,
        Constants.ObxRoles.FinanceTier3,
        Constants.ObxRoles.FinanceManager,
      ],
      component: Bills,
      exact: true,
      icon: <AttachMoney />,
      path: '/payproviders',
      text: 'Pay Providers',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.Administrator,
        Constants.ObxRoles.FinanceTier2,
        Constants.ObxRoles.FinanceManager,
      ],
      component: BillOut,
      exact: true,
      icon: <Receipt />,
      path: '/billOut',
      text: 'Bill Out',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.Administrator,
        Constants.ObxRoles.FinanceTier2,
        Constants.ObxRoles.FinanceManager,
      ],
      component: ReceivePayment,
      exact: true,
      icon: <CreditCard />,
      path: '/receivePayment',
      text: 'Receive Payment',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.Administrator,
        Constants.ObxRoles.FinanceTier2,
        Constants.ObxRoles.FinanceManager,
      ],
      component: ProviderRefunds,
      exact: true,
      icon: <CashRefund />,
      path: '/providerRefunds',
      text: 'Process Refunds',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      component: FinancialResearch,
      exact: true,
      icon: <Search />,
      path: '/financialResearch',
      text: 'Financial Research',
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      component: DocumentSearch,
      exact: true,
      icon: <InsertDriveFile />,
      path: '/documentSearch',
      text: 'Document Search',
    },
    {
      component: EasyQuery,
      exact: true,
      icon: <PageviewOutlined />,
      path: `/advancedSearch/:currentUserId`,
      text: 'Advanced Search',
      isDynamic: true,
    },
    {
      allowedOrganization: [OrganizationId.Surgical],
      allowedRoles: [
        Constants.ObxRoles.FinanceTier1,
        Constants.ObxRoles.FinanceManager,
        Constants.ObxRoles.Administrator,
      ],
      component: () => <ClaimsAcquisition />,
      exact: true,
      icon: <HeadsetMicRounded />,
      path: '/claimsAcquisition',
      text: 'Claims Acquisition',
    },
    {
      allowedRoles: [
        Constants.ObxRoles.ProviderInfoUpdater,
        Constants.ObxRoles.GeneralFinance,
        Constants.ObxRoles.Administrator,
        Constants.ObxRoles.WorkflowAdmin,
        Constants.OmxRoles.CaseManager,
        Constants.OmxRoles.CaseCoordinator,
      ],
      component: () => <AdminPages />,
      exact: true,
      icon: <Settings />,
      path: '/admin',
      text: 'Admin',
    },
    // DO NOT REMOVE -- USED FOR CODE GENERATION
  ],
}

const navigationSections: INavigationSection[] = [navigationSection]

let allRoutes = routes
navigationSections.forEach((section) => {
  allRoutes = allRoutes.concat(section.navigationRoutes)
})

export default allRoutes
export { INavigationRoute, INavigationSection, navigationSections }
